export const SET_OPENED_MENU_ITEM = 'SET_OPENED_MENU_ITEM'
export const ADD_FEED_MENU_ITEM = 'ADD_FEED_MENU_ITEM'
export const DELETE_FEED_MENU_ITEM = 'DELETE_FEED_MENU_ITEM'
export const UPDATE_FEED_MENU_ITEM = 'UPDATE_FEED_MENU_ITEM'
export const SET_FEED_MENU_ITEMS = 'SET_FEED_MENU_ITEMS'